export default {
    // ******************************************
    // Globals
    // ******************************************
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",

    // ******************************************
    // Globals - Locales
    // ******************************************
    locale_ar_ar_label_primary: "Arabo",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "Tedesco",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Greco",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "Inglese",
    locale_en_gb_label_secondary: "",
    locale_en_us_label_primary: "Inglese",
    locale_en_us_label_secondary: "Americano",
    locale_es_es_label_primary: "Spagnolo",
    locale_es_es_label_secondary: "",
    locale_es_la_label_primary: "Spagnolo",
    locale_es_la_label_secondary: "America Latina",
    locale_fa_ir_label_primary: "Persiano",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "Francese",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irlandese",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Ebraico",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italiano",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Giapponese",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Coreano",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Olandese",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polacco",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portoghese",
    locale_pt_br_label_secondary: "Brasile",
    locale_ru_ru_label_primary: "Russo",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Svedese",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Tagalog",
    locale_tl_ph_label_secondary: "Filippino",
    locale_tr_tr_label_primary: "Turco",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamita",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Cinese",
    locale_zn_cn_label_secondary: "Mandarino",

    // ******************************************
    // Nav Primary
    // ******************************************
    nav_primary_blog_label: "Blog",
    nav_primary_catalog_label: "Lingue E Prezzi",
    nav_primary_catalog_select_language_label: "Seleziona una Lingua",
    nav_primary_contact_label: "Contatti",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Hai domande? Chiamaci",
    nav_primary_phone_number: "1 (800) ROSETTA",
    nav_primary_sign_in_label: "ACCEDI",
    nav_primary_support_label: "Assistenza",
    nav_primary_vertical_education_primary_label: "Per Gli Educatori",
    nav_primary_vertical_enterprise_label: "Per Le Aziende",

    // ******************************************
    // Nav Secondary - Enterprise
    // ******************************************
    nav_secondary_enterprise_blog_label: "",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Home",
    nav_secondary_enterprise_label: "Aziende",
    nav_secondary_enterprise_resources_label: "Risorse",
    nav_secondary_enterprise_solutions_label: "Soluzioni",

    // ******************************************
    // Nav Secondary - Education Primary
    // ******************************************
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "Home",
    nav_secondary_education_primary_label: "Scuola Primaria e Secondaria",
    nav_secondary_education_primary_resources_label: "Risorse",
    nav_secondary_education_primary_solutions_label: "Soluzioni",

    // ******************************************
    // Nav Secondary - Education Secondary
    // ******************************************
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "Home",
    nav_secondary_education_secondary_label: "Istruzione Superiore",
    nav_secondary_education_secondary_resources_label: "Risorse",
    nav_secondary_education_secondary_solutions_label: "Risorse",

    // ******************************************
    // Nav Secondary - Education Homeschool
    // ******************************************
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",

    // ******************************************
    // Nav Secondary - Services
    // ******************************************
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",

    // ******************************************
    // Shared - Awards
    // ******************************************
    awards_header_label: "Approvato per 25+ anni dalle migliori organizzazioni",
    awards_bmw: "BMW",
    awards_ikea: "Ikea",
    awards_lego: "Lego",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",

    // ******************************************
    // Shared - Branded Quotes
    // ******************************************
    branded_quotes_header_label: "Cosa dicono di noi.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote:
        "&quot;<em>Il gioiello della corona</em> tra i metodi di apprendimento linguistico del computer.&quot;",
    branded_quotes_cnn_type: "cnn",

    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote:
        "&quot;Adoro il programma Rosetta Stone e penso che il tuo metodo per <em>L'apprendimento delle lingue funziona.</em>&quot;",
    branded_quotes_macworld_type: "macworld",

    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote:
        "&quot;Con la sua eccellente interfaccia per l'utente, istruzioni chiare e una vasta gamma di giochi e sfide ...  <em>Rosetta Stone sorprende.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",

    // ******************************************
    // Shared - Related Resources
    // ******************************************
    related_resources_label: "",
    related_resources_button_label: "",

    // ******************************************
    // Shared - Verticals
    // ******************************************
    verticals_label: "Che tipo di apprendista sei?",
    verticals_education_primary: "Scuola Primaria e Secondaria",
    verticals_education_secondary: "Istruzione Superiore",
    verticals_enterprise: "Aziende",
    verticals_publicsector: "",

    // ******************************************
    // Footer
    // ******************************************
    // CTA Form
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_email_sub_label: "",
    footer_cta_form_comments: "",
    footer_cta_form_country: "",
    footer_cta_form_email: "Email Professionale",
    footer_cta_form_firstname: "Nome",
    footer_cta_form_lastname: "Cognome",
    footer_cta_form_organization: "Nome dell'istituto",
    footer_cta_form_organizationsize: "Dimensione dell'organizzazione",
    footer_cta_form_organizationsize_100: "100 o meno",
    footer_cta_form_organizationsize_500: "101 - 500",
    footer_cta_form_organizationsize_1000: "501 - 1,000",
    footer_cta_form_organizationsize_5000: "1,001 - 5,000",
    footer_cta_form_organizationsize_10000: "5,001 - 10,000",
    footer_cta_form_organizationsize_25000: "10,001 - 25,000",
    footer_cta_form_organizationsize_50000: "25,001 - 50,000",
    footer_cta_form_organizationsize_more: "50,001 - Altro",
    footer_cta_form_phone: "Numero di telefono (facoltativo)",
    footer_cta_form_pricing_thanks: "Grazie per il tuo interesse! Qualcuno ti seguirà a breve.",
    footer_cta_form_role: "Ruolo (o titolo)",
    footer_cta_form_role_boardmember: "Membro di bordo",
    footer_cta_form_role_curriculumdirector: "Direttore del Curriculum / Coordinatore delle Istruzioni",
    footer_cta_form_role_director: "Direttore",
    footer_cta_form_role_executive: "Gestione Generale / Esecutiva",
    footer_cta_form_role_individualcontributor: "Collaboratore individuale",
    footer_cta_form_role_manager: "Manager",
    footer_cta_form_role_principal: "Direttore della Scuola",
    footer_cta_form_role_superintendent: "Sovrintendente / Amministratore Distrettuale",
    footer_cta_form_role_teacher: "Professore",
    footer_cta_form_role_techcoordinator: "Coordinatore Tecnologico",
    footer_cta_form_role_vicepresident: "Vice Presidente",
    footer_cta_form_submit: "CONSULENZA GRATUITA",
    footer_cta_how_hear_blog: "Blog",
    footer_cta_how_hear_email: "Email",
    footer_cta_how_hear_event: "Evento",
    footer_cta_how_hear_online: "In linea",
    footer_cta_how_hear_other: "Altro",
    footer_cta_how_hear_referral: "Remissione",
    footer_cta_how_hear_search: "Cercatore",
    footer_cta_how_hear_social: "Social Media",
    footer_cta_how_hear_title: "Come hai saputo di noi? (Opzionale)",
    footer_cta_how_hear_webinar: "Seminario Web",
    footer_cta_opt_in_learn_more_button_text: " qui",
    footer_cta_opt_in_learn_more_link_text_1: "qui.",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
    footer_cta_opt_in_learn_more_text_1:
        "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: ".",
    footer_cta_opt_in_text_after_button: "per maggiori informazioni.",
    footer_cta_opt_in_text_before_button:
        "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca",
    footer_cta_pricing_button: "CONSULTAZIONE DEI PREZZI",
    footer_cta_pricing_label: "Pronto per il prossimo passo?",
    footer_cta_pricing_subtitle: "Si prega di completare e ti contatteremo immediatamente.",
    footer_cta_pricing_title: "Ottieni informazioni sulle nostre tariffe.",

    // Menu
    footer_menu_about_about_us_label: "Rosetta Stone",
    footer_menu_about_careers_label: "Lavora Con Noi",
    footer_menu_about_contact_label: "Contatti",
    footer_menu_about_label: "Chi Siamo",
    footer_menu_about_press_label: "Stampa",
    footer_menu_products_demo_label: "Demo",
    footer_menu_products_education_primary_label: "Per gli Educatori",
    footer_menu_products_education_secondary_label: "Per gli Educatori Superiori",
    footer_menu_products_enterprise_label: "Per le Aziende",
    footer_menu_products_label: "Per Conoscerci Meglio",
    footer_menu_products_mobile_label: "Applicazioni Mobili",
    footer_menu_products_reviews_label: "Recensioni",
    footer_menu_support_faqs_label: "Domande frequenti",
    footer_menu_support_label: "Assistenza",
    footer_menu_support_support_site_label: "Supporto",
    footer_menu_support_system_requirements_label: "Requisiti di Sistema",

    // Meta
    footer_meta_agreements_label: "Condizioni generali di contratto",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Impostazioni cookie",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone GmbH. Tutti i diritti riservati.",
    footer_meta_privacy_policy_label: "Protezione dei dati",
    footer_meta_terms_conditions_label: "Informazioni legali",

    // Region
    footer_region_label: "Scegli il tuo paese",
    footer_region_options_au_label: "Australia",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",

    // Social
    footer_social_label: "Connettiti con noi",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};
